export enum ToleranceModes {
  NoTolerance = 0,
  Manual = 1,
  Iso21940 = 2,
}

export enum FilterQualityTypes {
  Fast = 0,
  Standard = 1,
  Precise = 2,
  Continuous = 3,
}

export enum DisplayInBalancing {
  WeightNumber = 0,
  WeightName = 1,
  WeightNameAndNumber = 2,
}

export enum RotorTypeStatuses {
  InCreation = 'InCreation',
  SetupMissing = 'SetupMissing',
  Ready = 'Ready',
}

export enum RotationDirections {
  Normal = 0,
  Reverse = 1,
}

export enum GeometryTypes {
  a = 'a',
  b = 'b',
  c = 'c',
  r1 = 'radius1',
  r2 = 'radius2',
  supportCase = 'supportCase',
}

export enum TolerancePositionTypes {
  t1 = 't1',
  t2 = 't2',
  cg = 'cg',
}

export enum RotorTypeCreationRequestTypes {
  AddMassMethod = 'RotorManager.Domain.Model.RotorTypeManagement.V1.RotorTypeMassCorrectionMethod',
  DrillMethod = 'RotorManager.Domain.Model.RotorTypeManagement.V1.RotorTypeDrillCorrectionMethod',
  PlaneGeometry = 'RotorManager.Domain.Model.RotorTypeManagement.V1.ABCGeometries',
  LocationFixed = 'RotorManager.Domain.Model.RotorTypeManagement.V1.RotorTypeFixedLocationsCorrectionDistribution',
  LocationSectors = 'RotorManager.Domain.Model.RotorTypeSectorsCorrectionDistribution',
  LocationFree = 'RotorManager.Domain.Model.RotorTypeManagement.V1.RotorTypePolarCorrectionDistribution',
  WeightSet = 'RotorManager.Domain.Model.RotorTypeManagement.V1.RotorTypeDifferentWeightsCorrectionMethod',
}

export enum RotorTypeSelections {
  Static = 1,
  Centered = 2,
  CenterRight = 3,
  OverhungRight = 4,
  Polar = 5,
  CenterLeft = 6,
  OverhungLeft = 7,
}

export enum CorrectionOrientations {
  Falling = 1,
  Rising = 2,
  Centered = 3,
}

export enum CorrectionMethod {
  AddMass = 1,
  RemoveMass = 2,
  Drill = 3,
  WeightSets = 4,
}

export enum RotorTypeSyncStates {
  Sync = 'Sync',
  Disabled = 'Disabled',
  Pending = 'Pending',
  Error = 'Error',
}

export enum CorrectionDrillTips {
  Standart = 1,
  General = 2,
  Cylinder = 3,
  Custom = 4,
}

export enum UnbalanceReadout {
  Static,
  Dynamic,
  StaticCouple,
  StaticDynamic,
}

export enum QualityGradeTypes {
  G0_4 = '0,4', // ISO-Tolerance grade: G 0.4
  G0_63 = '0,63', // ISO-Tolerance grade: G 0.63
  G1 = '1', // ISO-Tolerance grade: G 1
  G1_6 = '1,6', // ISO-Tolerance grade: G 1.6
  G2_5 = '2,5', // ISO-Tolerance grade: G 2.5
  G4 = '4', // ISO-Tolerance grade: G 4
  G6_3 = '6,3', // ISO-Tolerance grade: G 6.3
  G16 = '16', // ISO-Tolerance grade: G 16
  G40 = '40', // ISO-Tolerance grade: G 40
  G100 = '100', // ISO-Tolerance grade: G 100
  G250 = '250', // ISO-Tolerance grade: G 250
  G630 = '630', // ISO-Tolerance grade: G 630
  G1600 = '1600', // ISO-Tolerance grade: G 1600
  G4000 = '4000', // ISO-Tolerance grade: G 4000
}

export enum ReadoutRetentionType {
  Automatic,
  Manual,
}

export enum PositioningMode {
  None,
  ManualFree,
  ManualGuided,
  Automatic,
}

export enum TolerancePlanePositions {
  Measuring,
  Correction,
  Custom,
}

export enum LocationType {
  Static = 'Static',
  Sector = 'Sector',
  Fixed = 'Fixed',
  Free = 'Free',
}
